var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9260",
    "data-name": "Group 9260",
    transform: "translate(-406 -6143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 34,
    height: 34,
    rx: 17,
    transform: "translate(406 6143)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M3.6,16.07H.265V5.341H3.6ZM1.929,3.878A1.939,1.939,0,1,1,3.859,1.93,1.946,1.946,0,0,1,1.929,3.878ZM16.066,16.07H12.742V10.847c0-1.245-.025-2.841-1.732-2.841-1.732,0-2,1.352-2,2.751V16.07H5.684V5.341h3.2V6.8h.047a3.5,3.5,0,0,1,3.152-1.733c3.372,0,3.992,2.22,3.992,5.1V16.07Z",
    transform: "translate(414.923 6152.182)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.dd035e5404b51b5a20ae050c33c38aa2.svg";
export { ForwardRef as ReactComponent };